import React, { Component } from 'react';
//import logo from './logo.svg';
//import ear from './ear_512x512.png';
import couchcast_logo from './couchcast_logo.png';

import { Link } from "react-router-dom";

import './SignIn.css';

class SignIn extends Component {
  render() {

    function handleClick(e) {
      e.preventDefault();
      console.log('The link was clicked.');
      alert("Please wait a moment...");
    }

    function searchBoxChanged(e){
      e.preventDefault();
      var newvalue = e.target.value.toString();
      console.log('The search now says: ',newvalue);
      //document.getElementById("inputSignInSearchBox").value = newvalue;
    }

    /*
          <button className="btn-footer" id="startSignInInput" onClick={handleClick}>SignIn</button>
*/


    return (
      <div className="SignIn">
        <header className="SignIn-header">
            <h1 className="SignIn-title"></h1>
        </header>
        <article>
          <img src={couchcast_logo} className="SignIn-couchcast_logo" alt="couchcast_logo" />
        </article>
        <p className="SignIn-intro">
          
        </p>
        <footer className="footer">
          <div className="SignIn-footer">
            <Link to={`/SignInPage/`} className="btn-footer-home">Sign In</Link>
          </div>
                    
        </footer>
      </div>
    );
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/components/SignIn.js